<template>
  <div class="youkeshishijiankongqingkuang">
    <div class="total">
      目前客流人数 <span>{{ chartData.cur_num }}</span>
    </div>
    <ul>
      <li>
        <div class="line"></div>
        <div class="bg">
          <div class="list-bg">
            <div class="light">省外</div>
          </div>
          <div class="light-bar"></div>
        </div>
        <div class="text">{{ chartData.shengwai }}</div>
      </li>
      <li>
        <div class="line"></div>
        <div class="bg">
          <div class="list-bg">
            <div class="light">省内跨市</div>
          </div>
          <div class="light-bar"></div>
        </div>
        <div class="text">{{ chartData.shengnei }}</div>
      </li>
      <li>
        <div class="line"></div>
        <div class="bg">
          <div class="list-bg">
            <div class="light">市内游客</div>
          </div>
          <div class="light-bar"></div>
        </div>
        <div class="text">{{ chartData.shinei }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "YoukeShishiJiankongQingkuang",
  components: {},
  props: {
    chartData: {
      type: Object
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.youkeshishijiankongqingkuang {
  .total {
    span {
      font-size: 0.18rem;
      font-weight: bold;
      margin-left: 0.1rem;
      color: @light-blue;
    }
  }
  ul {
    li {
      width: 33.3333%;
      height: 1.8rem;
      float: left;
      position: relative;
      .bg {
        width: 1.2rem;
        height: 1.8rem;
        margin: 0 auto;
        .list-bg {
          width: 1.2rem;
          height: 1.2rem;
          background: url(../../assets/youkequntihuaxiang/list_bg.png);
          background-size: 100%;
          position: relative;
          overflow: hidden;
          .light {
            width: 1.2rem;
            height: 1.2rem;
            line-height: 1.2rem;
            background: url(../../assets/youkequntihuaxiang/light.png) no-repeat;
            background-size: 1100% 100%;
            animation: bird-slow 1s steps(10) infinite;
          }
        }
        .light-bar {
          width: 0.52rem;
          height: 1.2rem;
          background-image: linear-gradient(
            to bottom,
            rgba(34, 84, 178, 0.3),
            rgba(34, 84, 178, 0.01)
          );
          margin: -0.4rem auto 0;
        }
      }
      .text {
        position: absolute;
        bottom: 0.3rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.2rem;
        font-weight: bold;
      }
    }
    li:nth-child(1) .text {
      color: @light-blue;
    }
    li:nth-child(2) .text {
      color: #00d8ae;
    }
    li:nth-child(3) .text {
      color: #ffe05f;
    }
  }
}
@media screen and (max-height: 863px) {
  .youkeshishijiankongqingkuang ul li {
    height: 1.6rem;
    .text {
      bottom: 0.2rem;
    }
    .bg .light-bar {
      height: 0.9rem;
    }
  }
}
</style>
